/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectTaskLightResponseDto } from '../../models/core-project-task-light-response-dto';

export interface ProjectTasksControllerFindLightByTenant$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * Optional project ID to filter tasks by.
 */
  projectId?: string;

/**
 * Optional filter for tasks with sprint configuration (planned tasks only).
 */
  hasSprint?: boolean;
}

export function projectTasksControllerFindLightByTenant(http: HttpClient, rootUrl: string, params: ProjectTasksControllerFindLightByTenant$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectTaskLightResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectTasksControllerFindLightByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('projectId', params.projectId, {});
    rb.query('hasSprint', params.hasSprint, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectTaskLightResponseDto>>;
    })
  );
}

projectTasksControllerFindLightByTenant.PATH = '/o2-core/project-tasks/{tenant}/light';
